export enum InstitutionEnum {
  GETNET = 'Getnet',
  CANAL_5 = 'Canal 5',
  CANAL_1 = 'Canal 1',
}
